import { render, staticRenderFns } from "./AddReparingOrderType.vue?vue&type=template&id=aa5e4a52&"
import script from "./AddReparingOrderType.vue?vue&type=script&lang=js&"
export * from "./AddReparingOrderType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports